import API from './api';

class ChatService {
  sendMessage(formData) {
    return API.post(`/chat/send`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }

  getStudentChats(studentId) {
    return API.get(`/chat/student?student_id=${studentId}`);
  }

  getStudentUnreadCount(studentId) {
    return API.get(`/chat/student/unread?student_id=${studentId}`);
  }

  getAdminChatList(type) {
    return API.get(`/chat/admin/list?type=${type}`);
  }

  getAdminChatHistory(type, id) {
    return API.get(`/chat/admin/history?type=${type}&id=${id}`);
  }

  clearChat(receiverType, receiverId) {
    return API.post(`/chat/clear`, {
      receiver_type: receiverType,
      receiver_id: receiverId
    });
  }

  deleteMessage(id) {
    return API.post(`/chat/delete`, {
      id: id
    });
  }
}

export default new ChatService();
